import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.catalog}models/bySearchModel`;

export interface GetModelsBySearchModelQueryArgs {
  maxResult?: number;
  sellerId?: string;
  searchTerms?: string;
}

export interface ModelSummaryDto {
  id: string;
  // Keep the rest of fields flexible until a stricter model is required
  [key: string]: unknown;
}

export const getModelsBySearchModelRequest = (
  payload: GetModelsBySearchModelQueryArgs,
): ApiRequestDescriptor => ({
  url: buildUrl(ENDPOINT, {
    maxResult: payload.maxResult,
    sellerId: payload.sellerId,
    searchTerms: payload.searchTerms,
  }),
  config: { method: SUPPORTED_METHODS.GET },
});

export const getModelsBySearchModelQuery = async (
  payload: GetModelsBySearchModelQueryArgs,
): Promise<BackResponse<ModelSummaryDto[]> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<ModelSummaryDto[]>>(
      getModelsBySearchModelRequest(payload),
    );
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
